import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';
import { ConnectionRoot } from '@/app/connection-root';
import { BrandCard, BudsHeader, PageShell } from '@/app/buds-header';
import '@/styles/globals.css';

function ErrorFallback({ resetErrorBoundary }: FallbackProps) {
  return (
    <PageShell>
      <BudsHeader subtitle="Rewards for Shopify" />
      <BrandCard title="Something went wrong">
        <p className="text-sm leading-relaxed text-buds-dark/80">
          The page hit an unexpected error. Try again, and if it keeps failing
          contact Buds support.
        </p>
        <button
          type="button"
          onClick={resetErrorBoundary}
          className="mt-4 rounded-full bg-buds-dark px-4 py-2 text-sm font-semibold text-white transition hover:bg-buds-dark/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-buds-green"
        >
          Try again
        </button>
      </BrandCard>
    </PageShell>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(err) =>
        console.error('shopify-app error boundary caught:', err)
      }
    >
      <ConnectionRoot />
    </ErrorBoundary>
  </StrictMode>,
);
